import React from "react";
import blogs from "./BlogsSectionDetails";
import { useNavigate, useLocation } from "react-router-dom";

const BlogSection = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Check the current path to determine whether to show all blogs
    const isBlogPage = location.pathname === "/blog";

    // Display either all blogs or the first 6 based on the current route
    const displayedBlogs = isBlogPage ? blogs : blogs.slice(0, 6);

    const handleExploreAll = () => {
        navigate("/blog"); // Navigate to the blog page
    };

    return (
        <div className="container py-5">
            <h2 className="text-center mb-5">Blog</h2>
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                {displayedBlogs.map((blog) => (
                    <div key={blog.id} className="col">
                        <div
                            className="card h-100 border-0 shadow-sm"
                            onClick={() => navigate(`/blog/${blog.slug}`)}
                            style={{ cursor: "pointer" }}
                        >
                            <img
                                src={blog.image}
                                alt={blog.title}
                                className="card-img-top"
                                style={{
                                    borderRadius: "8px",
                                    height: "180px",
                                    objectFit: "cover",
                                }}
                            />
                            <div className="card-body">
                                <h5 className="" style={{ fontFamily: "Metropolis", fontWeight: "700", fontSize: "20px" }}>{blog.title}</h5>
                                <p className="" style={{ fontFamily: "Metropolis", fontWeight: "500", fontSize: "16px", color: "#5F626B", lineHeight: "22px" }}>{blog.description}</p>
                            </div>
                            <div className="d-inline-flex align-items-center p-2 m-2 read-more-btn">
                                <span className="px-2 text-dark fw-medium read-more-text">
                                    Read More
                                </span>
                                <img
                                    src="/img/blogs/rightArrow.png"
                                    alt="right arrow"
                                    style={{
                                        height: "14px",
                                        width: "22px",
                                        transition: "transform 0.3s ease"
                                    }}
                                    className="read-more-icon"
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {
                !isBlogPage && blogs.length > 6 && (
                    <div className="text-center mt-4">
                        <button className="btn btn-dark" onClick={handleExploreAll}>
                            Explore All
                        </button>
                    </div>
                )
            }
        </div >
    );
};

export default BlogSection;
